/**
 * portalCards.js
 * Single source of truth for all built-in portal definitions.
 * Adding a new portal only requires a new entry here.
 */
export const PORTAL_CARDS = [
  { id:"obc",      label:"OBC Development",     icon:"🛰️", path:"/obc_development",   color:"#00FFB2", collection:null, noFeed:true,
    desc:"CubeSat OBC — module tracker, BOM, design log, risk matrix, CubeSat compatibility" },
  { id:"mp",       label:"Mission Planning",    icon:"🛰", path:"/mission_planning",   color:"#6366f1", collection:"mission_planning_posts",
    desc:"GMAT simulations, trajectory analysis, orbital mechanics, coverage missions" },
  { id:"embedded", label:"Embedded Systems",    icon:"🔌", path:"/embedded_system",    color:"#f59e0b", collection:"embedded_posts",
    desc:"PCB design, schematics, Gerber files, firmware, BOM, test results" },
  { id:"system",   label:"Systems Engineering", icon:"⚙",  path:"/system_engineering", color:"#10b981", collection:"system_posts",
    desc:"CAD models, FEA, thermal, mass/power budgets, ICDs, system simulation" },
  { id:"ops",      label:"Operations",          icon:"🏛", path:"/operations",          color:"#e11d48", collection:"operations_posts",
    desc:"Daily briefs, mission status, launch ops, ground ops, anomaly reports, personnel updates" },
  { id:"c_suite",  label:"C-Suite",             icon:"👔", path:"/c_suite",             color:"#dc2626", collection:"c_suite_posts",
    msIcon:"corporate_fare", restricted:true, allowedRoles:['c_suite'],
    categories:[
      { id:"board",      label:"Board & Governance", icon:"🏛", color:"#dc2626" },
      { id:"strategy",   label:"Strategy",           icon:"🎯", color:"#f59e0b" },
      { id:"investor",   label:"Investor Relations", icon:"🏦", color:"#e11d48" },
      { id:"compliance", label:"Compliance",         icon:"✅", color:"#10b981" },
      { id:"general",    label:"General",            icon:"📁", color:"#64748b" },
    ],
    desc:"Executive reports, board updates, and director-level decisions" },
  { id:"payload",  label:"Payloads",            icon:"📦", path:"/payload",             color:"#0891b2", collection:"payload_posts",
    msIcon:"inventory_2",
    categories:[
      { id:"mass_budget",   label:"Mass Budget",        icon:"⚖",  color:"#0891b2" },
      { id:"interface",     label:"ICD / Interfaces",   icon:"🔗", color:"#6366f1" },
      { id:"integration",   label:"Integration",        icon:"🧩", color:"#10b981" },
      { id:"environmental", label:"Environmental",      icon:"🌡", color:"#f59e0b" },
      { id:"test",          label:"Test & Verification",icon:"🧪", color:"#8b5cf6" },
      { id:"general",       label:"General",            icon:"📁", color:"#64748b" },
    ],
    desc:"Payload integration, mass budgets, interfaces, and mission deliverables" },
  { id:"pe",       label:"Prompt Engineering",  icon:"🧠", path:"/prompt-engineering",  color:"#8b5cf6", collection:"prompt_engineering_posts",
    authorUidField:"submittedById", dateField:"submittedAt",
    desc:"Report portal issues, suggest prompt improvements, track quality reviews and admin approvals" },
  { id:"experimental", label:"Experimental Results", icon:"🧪", path:"/experimental_results", color:"#06b6d4", collection:null, noFeed:true,
    desc:"Log experiment runs, track results, attach data files, filter by category and status" },
  { id:"finance",  label:"Finance & Admin",     icon:"💰", path:"/finance_admin",        color:"#10b981", collection:null, noFeed:true,
    desc:"Invoice management with smart auto-sort, salary slip generation, spend analytics" },
  { id:"mentor",   label:"Investor Dashboard",  icon:"📊", path:"/mentor_dashboard",     color:"#7c3aed", collection:null, noFeed:true,
    desc:"Mission progress dashboard for mentors and investors — SPACEMANCRAFT-1 showcase" },
];
